import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { required } from '../../Helpers/validators';
import TerrorismField from './TerrorismField';
import HostLiquorField from './HostLiquorField';
import SellingLiquorField from './SellingLiquorField';
import PersonalPropertyField from './PersonalPropertyField';
import DamageToRentedPropertyField from './DamageToRentedPropertyField';
import { Button } from '@jauntin/react-ui';

const AdditionalCoverages = ({
  confirm,
  show,
  enabled,
  liquorPrice,
  damageToRentedPropertyPrice,
  hostLiquorHide,
  liquorLiabilityHide,
  personalPropertyHide,
  terrorismHide,
  damageToRentedPropertyHide,
  hostLiquorMandatory,
  liquorLiabilityMandatory,
  personalPropertyMandatory,
  terrorismMandatory,
  damageToRentedPropertyMandatory,
}) =>
  show && (
    <>
      <div className="form-row mb-3" hidden={terrorismHide}>
        <Field
          component={TerrorismField}
          validate={[required]}
          name="ACTerrorism"
          type="checkbox"
          disabled={terrorismMandatory || !enabled}
          enabled={enabled}
        />
      </div>
      <div className="form-row mb-3" hidden={personalPropertyHide}>
        <Field
          component={PersonalPropertyField}
          validate={[required]}
          name="ACPersonalProperty"
          type="checkbox"
          disabled={personalPropertyMandatory || !enabled}
        />
      </div>
      <div className="form-row mb-3" hidden={hostLiquorHide}>
        <Field
          component={HostLiquorField}
          validate={[required]}
          name="ACHostLiquor"
          type="checkbox"
          disabled={hostLiquorMandatory || !enabled}
        />
      </div>
      <div className="form-row mb-3" hidden={liquorLiabilityHide}>
        <Field
          component={SellingLiquorField}
          name="ACSellingLiquor"
          type="checkbox"
          liquorPrice={liquorPrice}
          disabled={liquorLiabilityMandatory || !enabled}
        />
      </div>
      <div className="form-row" hidden={damageToRentedPropertyHide}>
        <Field
          component={DamageToRentedPropertyField}
          name="ACDamageToRentedProperty"
          type="checkbox"
          damageToRentedPropertyPrice={damageToRentedPropertyPrice}
          disabled={damageToRentedPropertyMandatory || !enabled}
        />
      </div>
      <hr />
      <div className="float-right">
        <Button
          disabled={!enabled}
          onClick={confirm}
          text="Next"
          className="btn-primary"
        />
      </div>
    </>
  );

AdditionalCoverages.propTypes = {
  confirm: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  enabled: PropTypes.bool.isRequired,
  liquorPrice: PropTypes.number.isRequired,
  damageToRentedPropertyPrice: PropTypes.number.isRequired,
  hostLiquorHide: PropTypes.bool.isRequired,
  liquorLiabilityHide: PropTypes.bool.isRequired,
  personalPropertyHide: PropTypes.bool.isRequired,
  terrorismHide: PropTypes.bool.isRequired,
  damageToRentedPropertyHide: PropTypes.bool.isRequired,
  hostLiquorMandatory: PropTypes.bool.isRequired,
  liquorLiabilityMandatory: PropTypes.bool.isRequired,
  personalPropertyMandatory: PropTypes.bool.isRequired,
  terrorismMandatory: PropTypes.bool.isRequired,
  damageToRentedPropertyMandatory: PropTypes.bool.isRequired,
};

export default AdditionalCoverages;
